/**
 * HERO-02 — MUSKLE campaign poster collage
 * Edit hero02Media to swap assets. fit / focus control cropping.
 */
const hero02Media = [
  {
    id: 'left-lifestyle',
    type: 'image',
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-hydrate-lifestyle.png?v=114535385739414715931783019683",
    fit: 'cover',
    focus: 'center center',
    role: 'poster',
    energy: 'red',
  },
  {
    id: 'hydro-gold-product',
    type: 'image',
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-hydro-gold-product.jpeg?v=68624027245520694451783019683",
    fit: 'contain',
    focus: 'center center',
    role: 'cutout',
    energy: 'red',
  },
  {
    id: 'hydrate-product',
    type: 'image',
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-hydrate-pineapple-product.png?v=21238375015770350581783019685",
    fit: 'contain',
    focus: 'center center',
    role: 'cutout',
    energy: 'blue',
  },
  {
    id: 'creatine-lifestyle',
    type: 'video',
    poster: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-creatine-gummies-lifestyle.png?v=156965896047025976101783019685",
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-creatine-lifestyle.mp4?v=12551",
    simulate: true,
    fit: 'cover',
    focus: 'center 35%',
    role: 'poster',
    energy: 'blue',
  },
  {
    id: 'gummies-product',
    type: 'image',
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-creatine-gummies-strawberry.png?v=61587996014197954911783019686",
    fit: 'contain',
    focus: 'center center',
    role: 'cutout',
    energy: 'red',
  },
  {
    id: 'hydro-gold',
    type: 'image',
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-hydro-gold-lifestyle.png?v=43142957937225533721783019685",
    fit: 'cover',
    focus: 'center 65%',
    role: 'poster',
    energy: 'red',
  },
  {
    id: 'pancake-lifestyle',
    type: 'video',
    poster: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-protein-pancake-lifestyle.png?v=910988170530223161783019684",
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-pancake-lifestyle.mp4?v=12551",
    simulate: true,
    fit: 'cover',
    focus: 'center 40%',
    role: 'poster',
    energy: 'blue',
  },
  {
    id: 'protein-product',
    type: 'image',
    src: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-protein-pancake-product.jpeg?v=183567334860649987561783019683",
    fit: 'contain',
    focus: 'center center',
    role: 'cutout',
    energy: 'blue',
  },
];

const taglineItems = [
  { lead: 'Fuel your', accent: 'strength', accentColor: 'red' },
  { lead: 'Recover', accent: 'smarter', accentColor: 'blue' },
  { lead: 'Perform', accent: 'better', accentColor: 'red' },
];

const PANEL_ENTRANCE_MS = 1600;
const PANEL_STAGGER_MS = 220;
const PANEL_ENTRANCE_DELAY_MS = 400;
const LOGO_REVEAL_DELAY_MS = 1200;
const TAGLINE_START_DELAY_MS = 2200;
const TAGLINE_INTERVAL_MS = 5000;
const TAGLINE_TRANSITION_MS = 850;
const showTrustBadges = false;
const showHero02Numbers = false;

const hero02ReviewNumbers = {
  'left-lifestyle': 1,
  'hydro-gold': 2,
  'hydrate-product': 3,
  'gummies-product': 4,
  'creatine-lifestyle': 5,
  'pancake-lifestyle': 6,
  'protein-product': 7,
  'hydro-gold-product': 8,
};

const hero02ImageSwaps = [
  {
    targetId: 'gummies-product',
    replacementSrc: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-number-04-replacement.png?v=92217307292242999171783019685",
    delay: 1800,
  },
  {
    targetId: 'creatine-lifestyle',
    replacementSrc: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-number-05-replacement.jpeg?v=79786068868267448491783019685",
    delay: 3600,
  },
  {
    targetId: 'hydro-gold',
    replacementSrc: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-number-02-replacement.jpeg?v=125863894472737043241783019683",
    delay: 5400,
  },
  {
    targetId: 'hydro-gold-product',
    replacementSrc: "\/\/muskle.com\/cdn\/shop\/t\/2\/assets\/muskle-hero-03-number-08-replacement.jpg?v=153216299908657773291783019685",
    delay: 7200,
  },
];

const IMAGE_SWAP_DURATION_MS = 5200;

const PARALLAX_STRENGTH = 2.2;

(function () {
  'use strict';

  const hero = document.querySelector('.hero-02');
  const collageEl = document.getElementById('hero02-collage');
  const taglineEl = document.getElementById('hero02-tagline');
  const trustEl = document.getElementById('hero02-trust');
  if (!hero || !collageEl || !taglineEl) return;

  if (!showTrustBadges) {
    hero.classList.add('hero-02--no-trust');
    if (trustEl) trustEl.hidden = true;
  } else if (trustEl) {
    trustEl.hidden = false;
  }

  document.documentElement.style.setProperty('--logo-delay', LOGO_REVEAL_DELAY_MS + 'ms');
  document.documentElement.style.setProperty('--tagline-delay', TAGLINE_START_DELAY_MS + 'ms');
  document.documentElement.style.setProperty('--tagline-transition', (TAGLINE_TRANSITION_MS / 1000) + 's');

  function getImageSwap(item) {
    return hero02ImageSwaps.find(function (swap) {
      return swap.targetId === item.id;
    });
  }

  function appendSwapOverlay(parent, item, swap) {
    const overlay = document.createElement('img');
    overlay.className = 'hero-02__media hero-02__media--swap';
    if (item.type === 'video') {
      overlay.classList.add('hero-02__sim-video__poster');
    } else {
      overlay.classList.add('hero-02__media--image');
    }
    overlay.src = swap.replacementSrc;
    overlay.alt = '';
    overlay.loading = 'eager';
    overlay.decoding = 'async';
    applyMediaStyles(overlay, item);
    parent.appendChild(overlay);
  }

  function applyMediaStyles(el, item) {
    if (item.fit) el.style.objectFit = item.fit;
    if (item.focus) el.style.objectPosition = item.focus;
  }

  function buildEnergyStrip(item) {
    const strip = document.createElement('span');
    strip.className =
      'hero-02__layer-energy hero-02__layer-energy--' + (item.energy || 'red');
    strip.setAttribute('aria-hidden', 'true');
    return strip;
  }

  function buildSweep() {
    const sweep = document.createElement('span');
    sweep.className = 'hero-02__layer-sweep';
    sweep.setAttribute('aria-hidden', 'true');
    return sweep;
  }

  function buildImageContent(item) {
    const wrap = document.createElement('div');
    wrap.className = 'hero-02__media-wrap';
    if (item.role === 'cutout' || item.fit === 'contain') {
      wrap.classList.add('hero-02__media-wrap--cutout');
    }

    const img = document.createElement('img');
    img.className = 'hero-02__media hero-02__media--image';
    img.alt = '';
    img.src = item.src;
    img.loading = item.id === 'left-lifestyle' || item.id === 'gummies-product' ? 'eager' : 'lazy';
    img.decoding = 'async';
    applyMediaStyles(img, item);
    wrap.appendChild(img);

    const swap = getImageSwap(item);
    if (swap) {
      wrap.classList.add('hero-02__media-wrap--swap');
      appendSwapOverlay(wrap, item, swap);
    }

    return wrap;
  }

  function buildVideoContent(item) {
    const wrap = document.createElement('div');
    wrap.className = 'hero-02__media-wrap hero-02__media-wrap--video';

    const sim = document.createElement('div');
    sim.className = 'hero-02__sim-video';

    const posterSrc = item.poster || (item.src ? item.src.replace('.mp4', '.png') : '');
    const poster = document.createElement('img');
    poster.className = 'hero-02__sim-video__poster hero-02__media';
    poster.src = posterSrc;
    poster.alt = '';
    poster.loading = 'lazy';
    applyMediaStyles(poster, item);
    sim.appendChild(poster);

    const swap = getImageSwap(item);
    if (swap) {
      wrap.classList.add('hero-02__media-wrap--swap');
      appendSwapOverlay(sim, item, swap);
    }

    const glow = document.createElement('div');
    glow.className = 'hero-02__sim-video__glow hero-02__sim-video__glow--' + (item.energy || 'blue');
    sim.appendChild(glow);

    const sweep = document.createElement('div');
    sweep.className = 'hero-02__sim-video__sweep';
    sim.appendChild(sweep);

    const play = document.createElement('span');
    play.className = 'hero-02__video-play';
    play.setAttribute('aria-hidden', 'true');
    sim.appendChild(play);

    const video = document.createElement('video');
    video.className = 'hero-02__media hero-02__media--video';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.autoplay = true;
    video.hidden = true;
    if (item.poster) video.poster = item.poster;
    if (item.src && item.src.endsWith('.mp4')) video.src = item.src;
    applyMediaStyles(video, item);

    video.addEventListener('canplay', function () {
      video.hidden = false;
      sim.hidden = true;
      video.play().catch(function () {});
    });

    video.addEventListener('error', function () {
      video.hidden = true;
      sim.hidden = false;
    });

    wrap.appendChild(sim);
    wrap.appendChild(video);

    if (item.src && item.src.endsWith('.mp4')) video.load();

    return wrap;
  }

  function buildLayer(item, index) {
    const layer = document.createElement('article');
    layer.className =
      'hero-02__layer hero-02__layer--' + item.id +
      ' hero-02__layer--' + (item.role || 'poster');
    layer.dataset.layer = item.id;
    layer.style.animationDelay = (PANEL_ENTRANCE_DELAY_MS + index * PANEL_STAGGER_MS) + 'ms';
    layer.style.setProperty('--float-delay', (index * 0.65) + 's');

    const clip = document.createElement('div');
    clip.className = 'hero-02__layer-clip';

    const inner = document.createElement('div');
    inner.className = 'hero-02__layer-inner';

    const mediaWrap =
      item.type === 'video' ? buildVideoContent(item) : buildImageContent(item);
    inner.appendChild(mediaWrap);
    inner.appendChild(buildSweep());

    if (item.role === 'poster') {
      inner.appendChild(buildEnergyStrip(item));
    }

    const edge = document.createElement('span');
    edge.className = 'hero-02__layer-edge';
    edge.setAttribute('aria-hidden', 'true');
    inner.appendChild(edge);

    clip.appendChild(inner);
    layer.appendChild(clip);

    if (showHero02Numbers && hero02ReviewNumbers[item.id]) {
      const badge = document.createElement('span');
      badge.className = 'hero-02__debug-number';
      badge.textContent = String(hero02ReviewNumbers[item.id]);
      badge.setAttribute('data-number', String(hero02ReviewNumbers[item.id]));
      badge.setAttribute('aria-hidden', 'true');
      layer.appendChild(badge);
    }

    return layer;
  }

  function buildCollage() {
    collageEl.innerHTML = '';
    hero02Media.forEach(function (item, index) {
      collageEl.appendChild(buildLayer(item, index));
    });
  }

  function applyTaglineItem(index) {
    const line = taglineEl.querySelector('.hero-02__tagline-line');
    if (!line) return;
    const item = taglineItems[index];
    line.querySelector('.hero-02__tagline-lead').textContent = item.lead + ' ';
    const accent = line.querySelector('.hero-02__tagline-accent');
    accent.textContent = item.accent;
    accent.className = 'hero-02__tagline-accent hero-02__tagline-accent--' + item.accentColor;
  }

  function buildTaglines() {
    taglineEl.innerHTML = '';

    const line = document.createElement('p');
    line.className = 'hero-02__tagline-line hero-02__tagline-line--intro';

    const lead = document.createElement('span');
    lead.className = 'hero-02__tagline-lead';

    const accent = document.createElement('span');
    accent.className = 'hero-02__tagline-accent';

    line.appendChild(lead);
    line.appendChild(accent);
    taglineEl.appendChild(line);

    applyTaglineItem(0);
  }

  function initTaglineCycle() {
    const line = taglineEl.querySelector('.hero-02__tagline-line');
    if (!line || taglineItems.length < 2) return;

    let current = 0;

    setTimeout(function () {
      line.classList.remove('hero-02__tagline-line--intro');
      line.classList.add('hero-02__tagline-line--active');
    }, TAGLINE_START_DELAY_MS + 1000);

    setTimeout(function () {
      setInterval(function () {
        line.classList.remove('hero-02__tagline-line--active');
        line.classList.add('hero-02__tagline-line--exit');

        setTimeout(function () {
          current = (current + 1) % taglineItems.length;
          applyTaglineItem(current);
          line.classList.remove('hero-02__tagline-line--exit');
          line.classList.add('hero-02__tagline-line--active');
        }, TAGLINE_TRANSITION_MS);
      }, TAGLINE_INTERVAL_MS);
    }, TAGLINE_START_DELAY_MS + 1600);
  }

  function initParallax() {
    const layers = hero.querySelectorAll('.hero-02__layer');
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const isCoarse = window.matchMedia('(pointer: coarse)').matches;

    if (prefersReduced || isCoarse || window.innerWidth < 768) return;

    hero.addEventListener('mousemove', function (e) {
      const rect = hero.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;

      layers.forEach(function (layer, i) {
        if (!layer.classList.contains('hero-02__layer--live')) return;
        const dir = i % 2 === 0 ? 1 : -1;
        const depth = layer.classList.contains('hero-02__layer--cutout') ? 1.4 : 1;
        layer.style.setProperty('--px', (x * PARALLAX_STRENGTH * dir * depth) + 'px');
        layer.style.setProperty('--py', (y * PARALLAX_STRENGTH * 0.4 * dir) + 'px');
      });
    });

    hero.addEventListener('mouseleave', function () {
      layers.forEach(function (layer) {
        layer.style.setProperty('--px', '0px');
        layer.style.setProperty('--py', '0px');
      });
    });
  }

  function initVideoObserver() {
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (video.hidden) return;
          if (entry.isIntersecting) {
            video.play().catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.1 }
    );

    hero.querySelectorAll('video').forEach(function (v) {
      observer.observe(v);
    });
  }

  function initLayerEntrance() {
    const layers = hero.querySelectorAll('.hero-02__layer');
    const doneAt = PANEL_ENTRANCE_DELAY_MS + layers.length * PANEL_STAGGER_MS + PANEL_ENTRANCE_MS;

    layers.forEach(function (layer) {
      layer.addEventListener('animationend', function onEnd(e) {
        if (e.animationName === 'layerEnter') {
          layer.classList.add('hero-02__layer--live');
          layer.removeEventListener('animationend', onEnd);
        }
      });
    });

    setTimeout(function () {
      layers.forEach(function (l) {
        l.classList.add('hero-02__layer--live');
      });
    }, doneAt);
  }

  function initImageSwaps() {
    if (!hero02ImageSwaps.length) return;

    document.documentElement.style.setProperty(
      '--image-swap-duration',
      (IMAGE_SWAP_DURATION_MS / 1000) + 's'
    );

    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    hero02ImageSwaps.forEach(function (swap) {
      setTimeout(function () {
        const wrap = hero.querySelector(
          '.hero-02__layer--' + swap.targetId + ' .hero-02__media-wrap--swap'
        );
        if (!wrap) return;

        if (prefersReduced) {
          wrap.classList.add('hero-02__media-wrap--swap-complete');
          return;
        }

        wrap.classList.add('hero-02__media-wrap--swap-active');
      }, swap.delay);
    });
  }

  function elevateProductLayers() {
    var centerGlow = hero.querySelector('.hero-02__center-glow');
    if (!centerGlow) return;
    ['gummies-product', 'protein-product', 'hydro-gold-product'].forEach(function (id) {
      var layer = hero.querySelector('.hero-02__layer--' + id);
      if (layer) hero.insertBefore(layer, centerGlow);
    });
  }

  buildCollage();
  elevateProductLayers();
  buildTaglines();
  initTaglineCycle();
  initParallax();
  initVideoObserver();
  initLayerEntrance();
  initImageSwaps();
})();
